<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormSelect fieldName="contractor_id"
                                    label="Contractor"
                                    size="6"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.contractors"
                                    v-model:field="crud.contractor_id" />

                        <FormCalendar fieldName="from_date"
                                      label="Date from"
                                      size="3"
                                      validation="required"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.from_date" />

                        <FormCalendar fieldName="to_date"
                                      label="Date to"
                                      size="3"
                                      validation="required"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.to_date" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="2"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :beforeSave="beforeSave"
                         :buttonsVisibility="formProps.buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">

                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>

        <AlertAdd :formProps="{ source_table: 'workplans', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>

</template>

<script setup>
import { ref, onMounted, toRaw } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormSelect from '@crud/FormSelect.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import { __, getStoreValue, getStatusId, currentDate, getFromRoute, buttonClass, screenMessage, printReport } from '@helper/utils.js'
import { validation, initFormObj } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
    opportunityData: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref({})

const options = ["contractors"];
const select = ref(null);
const isAddAlertDialogOpen = ref(false);

// -----------------------------------------------------

onMounted(async () => {
    await initFormObj({ props, crud, isLoading, options, select });
})

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------


</script>

<style lang="scss" scoped></style>
